import { Grid, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { PlannedQtyDeviationInputs } from '../../types/app/plannedQtyDeviation.types';
import { SelectBoxAutocomplete } from '../../components/core/SelectBox/SelectBoxAutocomplete';
import { AssetDashboardSetting } from '../../types/app/asset.types';
import moment, { unitOfTime } from 'moment';
import { AllowedTime } from '../../types/app/plannedQty.types';
import { Timezone } from '../../components/app/TimezoneChanger/TimezoneChanger';
import { useTranslation } from '../../contexts/translation';
interface Props {
  onSubmit: SubmitHandler<PlannedQtyDeviationInputs>;
  defaultValues?: PlannedQtyDeviationInputs;
  onBack?: any;
  minutesStep?: any;
  settingData: AssetDashboardSetting;
  setSelectedTime: any;
  timezone: Timezone;
}

export const generateTimeData = (settingData: AssetDashboardSetting, timezone: Timezone) => {
  let newData: AllowedTime[] = [];
  // settingData.timeAggregation = "5m";
  const startTimeArray = ['00', '00', '00'];
  const tmpstartTime = new Date();
  tmpstartTime.setHours(Number(startTimeArray[0]));
  tmpstartTime.setMinutes(Number(startTimeArray[1]));
  tmpstartTime.setSeconds(Number(startTimeArray[2]));

  const splitGranularity = settingData.timeAggregation.split(/(\d+)/);

  let unit: unitOfTime.DurationConstructor = 'h';
  let dataCount = 0;
  const hoursPerDay = 24;

  if (splitGranularity[2] === 'h') {
    dataCount = hoursPerDay / Number(splitGranularity[1]);
    unit = 'h';
    if (dataCount < 0) {
      dataCount = dataCount * -1;
    }
  } else if (splitGranularity[2] === 'm') {
    dataCount = (hoursPerDay * 60) / Number(splitGranularity[1]);
    unit = 'm';
    if (dataCount < 0) {
      dataCount = dataCount * -1;
    }
  }

  for (let i = 0; i <= dataCount; i++) {
    let tmpTime =
      moment(tmpstartTime)
        .clone()
        .tz(timezone.value)
        .add(Number(splitGranularity[1]) * i, unit)
        .add(-1, 'hour')
        .format('HH:mm') +
      ' - ' +
      moment(tmpstartTime)
        .clone()
        .tz(timezone.value)
        .add(Number(splitGranularity[1]) * i, unit)
        .format('HH:mm');
    let tmpData: any;

    if (!tmpData) {
      tmpData = {
        time: tmpTime,
        id: i,
      } as AllowedTime;
    }
    newData = [...newData, tmpData];
  }
  return newData;
};

export function PlannedQtyDeviationForm({
  onSubmit,
  defaultValues,
  onBack,
  settingData,
  setSelectedTime,
  timezone,
}: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm<PlannedQtyDeviationInputs>();

  const times = generateTimeData(settingData, timezone).slice(1);

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      {times && (
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <SelectBoxAutocomplete
                label={t('page.dashboard.planned-qty-deviation.modal-input-1')}
                items={times}
                valueKey={'id'}
                labelKey={'time'}
                onChange={(value: any) => {
                  let tmpTime = times.find((x) => x.id === value);
                  setSelectedTime(tmpTime);
                }}
                controllerProps={{
                  name: 'time',
                  control: control,
                  rules: { required: t('page.dashboard.planned-qty-deviation.required-time') },
                }}
                errors={errors}
                isRequired={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label={t('page.dashboard.planned-qty-deviation.modal-input-2')}
                {...register('comment')}
                error={Boolean(errors.comment)}
                helperText={errors.comment?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label={t('page.dashboard.planned-qty-deviation.modal-input-3')}
                {...register('qty')}
                error={Boolean(errors.qty)}
                helperText={errors.qty?.message}
                type="number"
              />
            </Grid>
            <Grid item>
              <Stack spacing={2} direction="row">
                <Button type="button" variant="outlined" onClick={onBack}>
                  {t('general.action-buttons.back')}
                </Button>
                <Button type="submit" variant="contained" color="success">
                  {t('general.action-buttons.save')}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
}
